// src/components/layout/MainLayout.jsx
// -----------------------------------------------------------------------------
// Shell layout wrapping every authenticated page: Sidebar on the left,
// Header on top, page content in the middle (via <Outlet />), Footer at
// the bottom. Used once in App.jsx as the parent route for all protected
// pages, so individual pages only need to render their own content.
// -----------------------------------------------------------------------------
import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';

// Maps a route path prefix to a human-readable header title.
const PAGE_TITLES = {
  '/dashboard': 'Dashboard',
  '/tickets/': 'Ticket Detail',
  '/tickets': 'Tickets',
  '/ticket-status-history': 'Ticket Status History',
  '/ticket-link-types': 'Ticket Link Types',
  //AFIX_SIT_003
  // Bug	Ticket Mandatory, Severity, Status, Project Teams	The header above is named as Afix instead of module name 
  '/ticket-mandatory-fields': 'Ticket Mandatory Fields',
  //AFIX_SIT_003
  '/ticket-reopen-reasons': 'Ticket Reopen Reasons',
  //AFIX_SIT_003
  // Bug	Ticket Mandatory, Severity, Status, Project Teams	The header above is named as Afix instead of module name 
  '/ticket-severities': 'Ticket Severities',
  '/ticket-statuses': 'Ticket Statuses',
  //AFIX_SIT_003
  '/ticket-types': 'Ticket Types',
  '/projects/': 'Project Detail',
  '/projects': 'Projects',
  '/project-phases': 'Project Phases',
  '/project-environments': 'Project Environments',
  //AFIX_SIT_003
  // Bug	Ticket Mandatory, Severity, Status, Project Teams	The header above is named as Afix instead of module name 
  '/project-teams': 'Project Teams',
  //AFIX_SIT_003
  '/project-team-members': 'Project Team Members',
  '/client-organizations': 'Client Organizations',
  //AFIX_SIT_002
  // Bug	Client Questions	The header above is named as Afix instead of module name 
  '/client-questions': 'Client Questions',
  //AFIX_SIT_002
  '/users': 'Users',
  '/roles': 'Roles',
  '/permissions': 'Permissions Configuration',
  '/notifications': 'Notifications',
};

function getTitleForPath(pathname) {
  // Sort prefixes by length descending to match more specific routes (like /tickets/) first
  const sortedPrefixes = Object.keys(PAGE_TITLES).sort((a, b) => b.length - a.length);
  const match = sortedPrefixes.find((prefix) => pathname.startsWith(prefix));
  return match ? PAGE_TITLES[match] : 'AFix';
}

export default function MainLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  // Close mobile sidebar on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <div className="app-shell">
      {/* Mobile backdrop overlay */}
      {mobileOpen && (
        <div className="sidebar-overlay" onClick={() => setMobileOpen(false)} />
      )}

      <Sidebar collapsed={collapsed} mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />

      <div className="main-column">
        <Header
          title={getTitleForPath(location.pathname)}
          onToggleSidebar={() => {
            if (window.innerWidth <= 900) {
              setMobileOpen((o) => !o);
            } else {
              setCollapsed((c) => !c);
            }
          }}
        />

        <div className="page-content">
          {/* Each matched child route renders here - see routes in App.jsx */}
          <Outlet />
        </div>

        <Footer />
      </div>
    </div>
  );
}
